import { FC } from "react";
import { useKeycloak } from "@react-keycloak/web";

interface PrivateRouteProps {
  children: any;
}

const PrivateRoute: FC<PrivateRouteProps> = ({ children }) => {
  // const { keycloak } = useKeycloak();

  // const isLoggedIn = keycloak.authenticated;

  // return isLoggedIn ? children : null;
  let keycloakSession = {
    authenticated: false
  };
  let isLoggedIn = false;
  //@ts-ignore
  keycloakSession = JSON.parse(sessionStorage.getItem("keycloakSession"));
  if (keycloakSession != null) {
    isLoggedIn = keycloakSession.authenticated;
  }
  return isLoggedIn ? children : null;
};

export default PrivateRoute;
